import React, { FC, createContext, useMemo } from 'react';

export type PaginationContext = {
  totalRecords: number;
  pageLimit: number;
  currentPage: number;
  defaultResultSizeOptions: number[];
  onPageChanged: (pageData: { currentPage: number; pageLimit: number }) => void;
};

const PaginationReactContext = createContext<PaginationContext>(null);

export default PaginationReactContext;

export const usePaginationContext = (): PaginationContext => {
  const context = React.useContext(PaginationReactContext);

  if (!context) {
    throw new Error('usePaginationContext must be used within a PaginationProvider');
  }

  return context;
};

export const PaginationProvider: FC<PaginationContext> = ({
  children,
  totalRecords,
  pageLimit,
  currentPage,
  defaultResultSizeOptions,
  onPageChanged,
}) => {
  const ctxValue = useMemo(
    () => ({
      totalRecords,
      pageLimit,
      currentPage,
      defaultResultSizeOptions,
      onPageChanged,
    }),
    [totalRecords, pageLimit, currentPage, defaultResultSizeOptions, onPageChanged]
  );

  return <PaginationReactContext.Provider value={ctxValue}>{children}</PaginationReactContext.Provider>;
};
